
















































import CustomButton from "@/components/form/CustomButton.vue";
import { GlobalSettingsStorage } from "@/plugins/custom-interface";

interface IPasswordSettingsForm {
  min_length: number;
  max_length: number;
  include_digits: boolean;
  include_lower_characters: boolean;
  include_upper_characters: boolean;
}

import { Vue, Component } from "vue-property-decorator";
import { settingStorageApi } from "@/getinfo-api";
import { Setting as ISetting } from "@/api-v2/settings-storage/models/setting";
import CField from "@/components/form/CField.vue";
@Component({
  components: { CustomButton, CField }
})
export default class AdminPasswordValidatorSettings extends Vue {
  isSaveSettings: boolean = false;
  isShowGlobalSpinner: boolean = false;
  form: IPasswordSettingsForm = {
    min_length: 6,
    max_length: 180,
    include_digits: true, // должен ли пароль содержать цифры
    include_lower_characters: true, // должен ли пароль содержать строчные латинские буквы
    include_upper_characters: true // должен ли пароль содержать заглавные латинские буквы
  };

  get settings() {
    return GlobalSettingsStorage;
  }

  saveSettings() {
    this.isSaveSettings = true;
    const passwordValidatorSettings: ISetting = {
      name: this.settings.PasswordValidatorSettings,
      value: this.form
    };

    settingStorageApi.Global.putGlobalSettings([passwordValidatorSettings])
      .then(() => {
        this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Successful)}`
        });
      })
      .catch(err => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSaveSettings = false;
      });
  }

  getPasswordValidatorSettings() {
    this.isShowGlobalSpinner = true;
    settingStorageApi.Global.getGlobalSettings([
      this.settings.PasswordValidatorSettings
    ])
      .then((res: { data: Array<ISetting> }) => {
        if (
          res.data?.[0]?.name === this.settings.PasswordValidatorSettings &&
          res.data?.[0].value
        ) {
          //@ts-ignore
          this.form = res.data?.[0].value;
        }
      })
      .finally(() => {
        this.isShowGlobalSpinner = false;
      });
  }

  created() {
    this.getPasswordValidatorSettings();
  }
}
